import axios from "axios";
import _encrypt from "./_encrypt";

export default async function _api(props, _server = process.env.REACT_APP_SERVER_API_LOCAL) {
  if (props.method === "server") return _server;

  props.resetAlert();
  props.setLoading()

  function uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      // eslint-disable-next-line no-mixed-operators
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }

  const prm = {
    user: props.guid,
    token: uuidv4(),
    dateStamp: new Date().toLocaleDateString(),
    timeStamp: new Date().toLocaleTimeString(),
  };

  const resolver = async (res = null, err = null) => {
    if (res === null) {
      try {
        if (err.response.status === 401) {
          sessionStorage.removeItem("session");
          localStorage.removeItem("u");
          //window.location.reload();
        }
      } catch {}
    }

    const alert = {
      variant: res !== null ? props.VARIANT.SUCCESS : props.VARIANT.DANGER,
      title: res !== null ? "" : "Omlouváme se",
      text: res !== null ? props.successText === undefined ? "" :  props.successText : "Něco se nepovedlo. Zkuste to prosím znovu. V případě přetrvávajících problému nás kontaktujte na info@britex.cz"
    }

    props.setAlert(alert);

    const data = res !== null ? res.data : err.data !== undefined ? err.data : err.response.data !== undefined ? err.response.data : ""
    const decData = props.decryptData ? await props._decrypt(data) : data;
    const parseData = props.jsonParseData ? await JSON.parse(decData) : decData;
    props.setLoading(false)
    return {
      status: res !== null ? res.status : err.status !== undefined ? err.status : err.response.status !== undefined ? err.response.status : 500,
      data: parseData,
      loading: false,
      alert: alert
    };
  }
  if (props.method === "put") {
    debugger;
    return await axios
      .put(
        _server + props.endpoint,
        JSON.stringify(props.data),
        {
          headers: {
            'content-type': 'application/json',
            'AppParams': _encrypt(JSON.stringify(prm)).replaceAll('/','|'),
          },
        }
      )
      .then((res) => {
        return resolver(res);
      })
      .catch((err) => {
        return resolver(null,err);
      });
  }
  if (props.method === "post") {
    return await axios
      .post(
        _server + props.endpoint,
        JSON.stringify(props.data),
        {
          headers: {
            'content-type': 'application/json',
            'AppParams': _encrypt(JSON.stringify(prm)).replaceAll('/','|'),
          },
        }
      )
      .then((res) => {
        return resolver(res);
      })
      .catch((err) => {
        return resolver(null,err);
      });
  } else {
    return await axios
      .get(_server + props.endpoint + props?.param, {
        withCredentials: false,
        headers: {
          'AppParams': _encrypt(JSON.stringify(prm)).replaceAll('/','|'),
        },
      })
      .then((res) => {
        return resolver(res);
      })
      .catch((err) => {
        return resolver(null,err);
      });
  }
}
